import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "./base.http.service";
import { Config } from "src/app/shared/types/contract-types";

@Injectable({
  providedIn: "root",
})
export class ConfigService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  private apiUrlWithEndpoint(endpoint: string): string {
    return `${this.apiUrl}/api/config/${endpoint}`;
  }

  updateConfig(configId: number | null, config: Config): Observable<Config> {
    return this.http.put<Config>(
      this.apiUrlWithEndpoint(`${configId}`),
      config,
    );
  }

  getConfig(configId: number): Observable<Config> {
    return this.http.get<Config>(this.apiUrlWithEndpoint(`${configId}`));
  }

  applyConfig(configId: number | null): Observable<boolean> {
    return this.http.put<boolean>(
      this.apiUrlWithEndpoint(`${configId}/apply`),
      {},
    );
  }
}
